import React from "react";
// import { Animated } from "react-animated-css";
import { LoadingPageStyled } from "./loadingPage.styles";

const LoadingPage = ({ isShow }) => {
  return (
    // <Animated
    //   animationIn="bounceInRight"
    //   //   animationOut="bounceOutRight"
    //   animationInDuration={500}
    //   //   animationOutDuration={500}
    //   isVisible={isShow}
    //   className={`animated position-relative align-self-end`}
    // >
    <LoadingPageStyled isShow={isShow}>
      <div className="loading-page__inner">
        <div className="text-muted">لطفا صبر کنید</div>
        <div className="spinner-border text-warning" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    </LoadingPageStyled>
    // {/* </Animated> */}
  );
};

export default LoadingPage;
